import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Ionic 6 détecte le natif via window.Capacitor.isNative, propriété supprimée
// de Capacitor depuis la v5 : sans ce shim, platform.is('capacitor') renvoie
// false sur tablette et l'appli se croit en mode web (setDevice jamais appelé,
// barres système visibles, bouton caché absent...).
if ((window as any).Capacitor) {
  (window as any).Capacitor.isNative = Capacitor.isNativePlatform();
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
